import { Modal } from '@salecycle/ui-component-library';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StartDateAndTimeControl } from './StartDateAndTimeControl';
import { EndDateAndTimeControl } from './EndDateAndTimeControl';

export interface ScheduledDatesModalProps {
  open: boolean;
  onClose: () => void;
}

export const ScheduledDatesModal = ({ open, onClose }: ScheduledDatesModalProps) => {
  const { t } = useTranslation('campaigns');
  const theme = useTheme();

  return (
    <Modal
      heading={t('onsite.editor.workflow.scheduling.datesModal.heading')}
      variation="clean"
      isOpen={open}
      onCloseButtonClicked={onClose}
      cancelButtonLabel={t('onsite.editor.workflow.displayWebContentMessage.scheduling.datesModal.done')}
      cancelButtonAriaLabel={t('onsite.editor.workflow.displayWebContentMessage.scheduling.datesModal.done')}
      onOkButtonClicked={onClose}
      okButtonLabel={t('onsite.editor.workflow.displayWebContentMessage.scheduling.datesModal.done')}
      okButtonAriaLabel={t('onsite.editor.workflow.displayWebContentMessage.scheduling.datesModal.done')}
      overflow="visible"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: theme.designToken.spacing3 }}>
        <StartDateAndTimeControl key="campaign-schedule-start" />
        <EndDateAndTimeControl key="campaign-schedule-end" />
      </div>
    </Modal>
  );
};
